import { AnalyticsTypes } from '../../../../../middleware/google-analytics';
import { APPOINTMENT_DETAILS_GA_CATEGORY } from '../../../../pages/AppointmentDetails/constants';
import { ACTION_PREFIX, GaActionText } from '../../constants';

export const CHANGE_ADDRESS_1 = `${ACTION_PREFIX}/CHANGE_ADDRESS_1`;
export const CHANGE_ADDRESS_2 = `${ACTION_PREFIX}/CHANGE_ADDRESS_2`;
export const CHANGE_CITY = `${ACTION_PREFIX}/CHANGE_CITY`;
export const CHANGE_STATE = `${ACTION_PREFIX}/CHANGE_STATE`;
export const CHANGE_ZIP = `${ACTION_PREFIX}/CHANGE_ZIP`;

export const TRACK_SELECT_ADDRESS_FORM_ADDRESS_1 = `${ACTION_PREFIX}/TRACK_SELECT_ADDRESS_FORM_ADDRESS_1`;
export const TRACK_SELECT_ADDRESS_FORM_ADDRESS_2 = `${ACTION_PREFIX}/TRACK_SELECT_ADDRESS_FORM_ADDRESS_2`;
export const TRACK_SELECT_ADDRESS_FORM_CITY = `${ACTION_PREFIX}/TRACK_SELECT_ADDRESS_FORM_CITY`;
export const TRACK_SELECT_ADDRESS_FORM_STATE = `${ACTION_PREFIX}/TRACK_SELECT_ADDRESS_FORM_STATE`;
export const TRACK_SELECT_ADDRESS_FORM_ZIP = `${ACTION_PREFIX}/TRACK_SELECT_ADDRESS_FORM_ZIP`;
export const UPDATE_ADDRESS_FAILURE = `${ACTION_PREFIX}/UPDATE_ADDRESS_FAILURE`;

const apiHost = process.env.API_HOST || '';
const updateAddressEndpoint = (mainPatientId) =>
    `${apiHost}/api/web/2/patient/${mainPatientId}/address`;

export const AddressFormActions = {
    CHANGE_ADDRESS_1,
    CHANGE_ADDRESS_2,
    CHANGE_CITY,
    CHANGE_STATE,
    CHANGE_ZIP,
    TRACK_SELECT_ADDRESS_FORM_ADDRESS_1,
    TRACK_SELECT_ADDRESS_FORM_ADDRESS_2,
    TRACK_SELECT_ADDRESS_FORM_CITY,
    TRACK_SELECT_ADDRESS_FORM_STATE,
    TRACK_SELECT_ADDRESS_FORM_ZIP,
    UPDATE_ADDRESS_FAILURE,
};

export function changeAddress1(address1) {
    return {
        type: CHANGE_ADDRESS_1,
        payload: {
            address1,
        },
    };
}

export function changeAddress2(address2) {
    return {
        type: CHANGE_ADDRESS_2,
        payload: {
            address2,
        },
    };
}

export function changeCity(city) {
    return {
        type: CHANGE_CITY,
        payload: {
            city,
        },
    };
}

export function changeState(selectedState) {
    return {
        type: CHANGE_STATE,
        payload: {
            selectedState,
        },
    };
}

export function changeZip(zip) {
    return {
        type: CHANGE_ZIP,
        payload: {
            zip,
        },
    };
}

export function updateAddress(
    mainPatientId,
    address,
    updateSuccess,
    updateFailure
) {
    return (dispatch) => {
        const fetchData = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                address_line_1: address.address1,
                address_line_2: address.address2,
                city: address.city,
                state: address.selectedState,
                zip_code: address.zip,
            }),
            credentials: 'include',
        };

        let responseStatus;
        return fetch(updateAddressEndpoint(mainPatientId), fetchData)
            .then((response) => {
                responseStatus = response.status;
                if (responseStatus >= 200 && responseStatus < 300) {
                    return dispatch(updateSuccess());
                }

                return dispatch(updateFailure());
            })
            .catch(() => {
                dispatch(updateFailure());
            });
    };
}

export const trackSelectAddress1 = () => ({
    type: TRACK_SELECT_ADDRESS_FORM_ADDRESS_1,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_DETAILS_GA_CATEGORY,
            action: GaActionText.trackSelectAddress1,
        },
    },
});

export const trackSelectAddress2 = () => ({
    type: TRACK_SELECT_ADDRESS_FORM_ADDRESS_2,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_DETAILS_GA_CATEGORY,
            action: GaActionText.trackSelectAddress2,
        },
    },
});

export const trackSelectCity = () => ({
    type: TRACK_SELECT_ADDRESS_FORM_CITY,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_DETAILS_GA_CATEGORY,
            action: GaActionText.trackSelectCity,
        },
    },
});

export const trackSelectState = () => ({
    type: TRACK_SELECT_ADDRESS_FORM_STATE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_DETAILS_GA_CATEGORY,
            action: GaActionText.trackSelectState,
        },
    },
});

export const trackSelectZip = () => ({
    type: TRACK_SELECT_ADDRESS_FORM_ZIP,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_DETAILS_GA_CATEGORY,
            action: GaActionText.trackSelectZip,
        },
    },
});

export const updateAddressFailure = (errors) => {
    const parsedErrors = errors.reduce((prev, error) => {
        prev[error.name] = error.message;
        return prev;
    }, {});

    return {
        type: UPDATE_ADDRESS_FAILURE,
        errors: parsedErrors,
    };
};

export const AddressFormActionCreators = {
    trackSelectAddress1,
    trackSelectAddress2,
    trackSelectCity,
    trackSelectState,
    trackSelectZip,
};
